<template>
  <div class="first-look">
    <div style="width: 150%;height: 200px;background-color: black"></div>
    <BannerTaiShi>
      <!-- 裁刀垂直 -->
      <div class="custom-slide">
        <div class="custom-slide-img">
          <img src="../../static/series/evo/smartknife1.png">
        </div>
        <div class="custom-slide-text">
          <div style="width: 200%">
            <p>
              {{ $t('series.banner_one_text1') }}<br>{{
                $t('series.banner_one_text2')
              }}<br>{{ $t('series.banner_one_text3') }}
            </p>
          </div>
          <img src="../../static/series/evo/smartknife2.png" alt="">
          <div class="custom-slide-text2">
            <p v-if="this.$i18n.locale === 'zh'">太势S系裁床 搭载<br>
              PrimeForce<br>
              Advanced Intelligent Cutting Correction (ICC)<br>
              高效刀智能纠偏装置<br>
              与众不同的刀智能机构，使太势裁床在高层裁剪中，<br>
              时刻保持<span style="color: #d86ecc">裁刀垂直切割</span>
            </p>
            <p v-else>{{ $t('series.banner_one_text4') }}<br>
              PrimeForce<br>
              <span style="color: #44b1e1">Advanced Intelligent Cutting Correction (ICC)</span><br>
              {{ $t('series.banner_one_text5') }}<br>
              {{ $t('series.banner_one_text6') }}
            </p>
          </div>
        </div>
      </div>
      <!-- 智能对称 -->
      <div class="custom-slide2">
        <div class="custom-slide2-imgs">
          <img src="../../static/series/evo/MirrorCut1.png" alt="">
          <img src="../../static/series/evo/MirrorCut2.png" alt="">
          <img src="../../static/series/evo/MirrorCut3.png" alt="">
          <img src="../../static/series/evo/MirrorCut4.png" alt="">
        </div>
        <div class="custom-slide2-text">
          <p>PrimeForce MirrorCut</p>
          <p>{{ $t('series.banner_second_text1') }}</p>
          <p>{{ $t('series.banner_second_text2') }}<br>
            {{ $t('series.banner_second_text3') }}<br>
            <span v-if="this.$i18n.locale === 'en'">
              {{ $t('series.banner_second_text4') }}
            </span>
          </p>
        </div>
      </div>
      <!-- 弧线圆滑 -->
      <div class="custom-slide3">
        <div class="custom-slide3-imgs">
          <img src="../../static/series/evo/circle1.png" alt="">
          <img src="../../static/series/evo/circle2.png" alt="">
          <img src="../../static/series/evo/circle3.png" alt="">
        </div>
        <div v-if="this.$i18n.locale === 'zh'" class="custom-slide3-text">
          <p>弧线圆滑功能。</p>
          <p>弧线路径自动插补优化，<br>
            弧线裁剪速度自动调整，<br>弧线波浪剪裁<span style="color: #0f9ed5">更光滑。</span></p>
        </div>
        <div v-else class="custom-slide3-text">
          <p style="color: white"><span style="color: #44b1e1">FlowCut</span> Technology</p>
          <p>Smart Path Optimization.<br>
            Auto-Speed for Curves.
            <br>Silky Wave Cutting Results.</p>
        </div>
      </div>
      <!-- 共边裁剪 -->
      <div class="custom-slide6">
        <div v-if="this.$i18n.locale === 'zh'" class="custom-slide6-text">
          <img src="../../static/FirstLook/图片3.png" alt="">
          <img src="../../static/FirstLook/图片4.png" alt="">
        </div>
        <div v-else class="custom-slide6-text">
          <img src="../../static/FirstLook/图片3-1.png" alt="">
          <img src="../../static/FirstLook/图片4-1.png" alt="">
        </div>
        <div class="custom-slide6-imgs">
          <img src="../../static/FirstLook/图片5.png" alt="">
          <img src="../../static/FirstLook/图片6.png" alt="">
        </div>
      </div>
      <!-- 小间隙裁剪 -->
      <div class="custom-slide4">
        <div class="custom-slide4-img">
          <img src="../../static/series/evo/pressingKnife1.png" alt="">
        </div>
        <div class="custom-slide4-text">
          <p>{{ $t('series.banner_three_text1') }}</p>
          <p>{{ $t('series.banner_three_text2') }}</p>
          <p>{{ $t('series.banner_three_text3') }}</p>
        </div>
        <div class="custom-slide4-imgs">
          <img src="../../static/series/evo/pressingKnife2.png" alt="">
          <img src="../../static/series/evo/pressingKnife3.png" alt="">
          <div class="custom-slide4-text2">
            <p>{{ $t('series.banner_three_text4') }}</p>
            <p>{{ $t('series.banner_three_text5') }}</p>
          </div>
        </div>
      </div>
      <!-- 0间隙裁剪 -->
      <div class="custom-slide7">
        <div class="custom-slide7-text">
          <img src="../../static/FirstLook/图片7.png" alt="">
          <img src="../../static/FirstLook/图片8.png" alt="">
        </div>
        <div v-if="this.$i18n.locale === 'zh'" class="custom-slide7-img">
          <img src="../../static/FirstLook/图片9.png" alt="">
          <img src="../../static/FirstLook/图片10.png" alt="">
        </div>
        <div v-else class="custom-slide7-img">
          <img src="../../static/FirstLook/图片9-1.png" alt="">
          <img src="../../static/FirstLook/图片10-1.png" alt="">
        </div>
      </div>
      <!-- 小裁片 -->
      <div class="custom-slide8">
        <div class="custom-slide8-text">
          <img src="../../static/FirstLook/图片12.png" alt="">
        </div>
        <div class="custom-slide8-img">
          <div class="custom-slide8-text1">
            {{ $t('series.banner_four_text1') }}<br>
            {{ $t('series.banner_four_text2') }}
          </div>
          <div v-if="this.$i18n.locale === 'zh'" class="custom-slide8-text2">
            大片先裁后，真空吸附力减弱，<br>
            容易造成小裁片裁剪质量下降。
          </div>
          <div v-if="this.$i18n.locale === 'zh'" class="custom-slide8-text3">
            太势EVO裁剪系统，<br>
            自动优化裁剪顺序，<br>
            分区优先裁剪小裁片，窄裁片。<br>
            同时智能优化下刀点和裁剪方向。<br>
            裁片靠得再近，<br>
            变换下刀提刀位置也不伤片，<br>
            这个系统就是这么机智。
          </div>
          <div v-else class="custom-slide8-text3">
            {{ $t('series.banner_four_text3') }}<br>
            {{ $t('series.banner_four_text4') }}<br>
            {{ $t('series.banner_four_text5') }}<br>
            {{ $t('series.banner_four_text6') }}<br>
            {{ $t('series.banner_four_text7') }}<br>
            {{ $t('series.banner_four_text8') }}
          </div>
        </div>
      </div>
      <!-- 临片减速 -->
      <div class="custom-slide9">
        <div class="custom-slide9-text">
          <div class="custom-slide9-text1">
            {{ $t('series.banner_five_text1') }}<br>
            {{ $t('series.banner_five_text2') }}<br>
            {{ $t('series.banner_five_text3') }}
          </div>
          <div class="custom-slide9-text2">
            {{ $t('series.banner_five_text4') }}<br>
            {{ $t('series.banner_five_text5') }}<br>
            {{ $t('series.banner_five_text6') }}<br>
            {{ $t('series.banner_five_text7') }}<br>
            {{ $t('series.banner_five_text8') }}
          </div>
        </div>
        <div class="custom-slide9-img">
          <img src="../../static/FirstLook/图片13.png" alt="">
        </div>
      </div>
      <!-- 断点续裁 -->
      <div class="custom-slide10">
        <div class="custom-slide10-text">
          <div class="custom-slide10-text1">
            {{ $t('series.banner_six_text1') }}<br>
            {{ $t('series.banner_six_text2') }}
          </div>
          <div class="custom-slide10-text2">
            {{ $t('series.banner_six_text3') }}<br>
            {{ $t('series.banner_six_text4') }}<br>
            {{ $t('series.banner_six_text5') }}
          </div>
        </div>
        <div class="custom-slide10-img">
          <img src="../../static/FirstLook/图片14.png" alt="">
        </div>
      </div>
    </BannerTaiShi>
    <div style="width: 150%;height: 200px;background-color: black"></div>
  </div>

</template>

<script>

import {defineComponent} from "vue";
import BannerTaiShi from "@/components/Series/BannerTaiShi.vue";

export default defineComponent({
  components: {BannerTaiShi},
  mounted() {
    this.$nextTick(() => {
      let elements = ['.custom-slide',
        '.custom-slide2',
        '.first-look'
      ]
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: elements,
          start: 'top 100%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 2,
          toggleActions: 'play none none none',
          once: true
        }
      })

      masterTimeline.from(elements[0], {
        opacity: 0,
        y: 50,
        duration: 0.8,
        ease: 'power2.in'
      })

      masterTimeline.from(elements[1], {
        opacity: 0,
        y: 50,
        duration: 0.8,
        ease: 'power2.in'
      }, "-=0.2")

      // 添加离场动画

      // masterTimeline.to(elements[2], {
      //   opacity: 0,
      //   y: -200,
      //   duration: 1
      // })
    })
  }
})
</script>
<style scoped>
.custom-slide10 {
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.custom-slide10-text {
  position: relative;
  width: 45%;
  height: 100%;
  color: white;
  top: 20%;
  left: 5%;
  text-align: left;
}

.custom-slide10-text1 {
  font-size: 2.5em;
  color: #61cbf4;
}

.custom-slide10-text2 {
  margin-top: 20px;
}

.custom-slide10-img {
  height: 100%;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;

  img {
    width: 90%;
    height: 90%;
  }
}


.custom-slide9 {
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.custom-slide9-text {
  position: relative;
  width: 45%;
  height: 100%;
  color: white;
  top: 20%;
  left: 5%;
  text-align: left;
}

.custom-slide9-text1 {
  font-size: 2.5em;
  color: #61cbf4;
}

.custom-slide9-text2 {
  margin-top: 20px;

}

.custom-slide9-img {
  height: 100%;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}


.custom-slide8 {
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.custom-slide8-text {
  height: 100%;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: left;
  line-height: 1.5;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.custom-slide8-img {
  height: 100%;
  width: 45%;
  color: white;
  display: flex;
  flex-direction: column;
  text-align: left;
  position: relative;
  top: 20%;
  left: 5%;
}

.custom-slide8-text1 {
  color: #d86ecc;
  font-size: 2.5em;
}

.custom-slide8-text2 {
  color: #808080;
  line-height: 1.5;
}

.custom-slide8-text3 {
  line-height: 1.5;
  margin-top: 20px;
}


.custom-slide7 {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.custom-slide7-text {
  width: 50%;

  img {
    width: 100%;
    height: 50%;
  }
}

.custom-slide7-img {
  position: relative;
  top: 30%;
  left: 3%;
  width: 50%;
}

.custom-slide7-img img:nth-of-type(1) {
  width: 100%;
}

.custom-slide7-img img:nth-of-type(2) {
  width: 100%;
}


.custom-slide6 {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.custom-slide6-text {
  position: relative;
  top: 20%;
  left: 5%;
  width: 50%;
}

.custom-slide6-text img:nth-of-type(1) {
  width: 100%;
}

.custom-slide6-text img:nth-of-type(2) {
  width: 100%;
}

.custom-slide6-imgs {
  width: 50%;
}

.custom-slide6-imgs img {
  height: 50%;
}


.custom-slide5 {
  position: relative;
  display: flex;
}

.custom-slide5-image {
  position: absolute;
  bottom: 0;
  height: 35%;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
  }
}

.custom-slide5-text {
  position: absolute;
  width: 50%;
  top: 20%;
  left: 10%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.custom-slide5-text p:nth-of-type(1) {
  color: white;
  font-size: 2.5em;
  margin-bottom: 0;
}

.custom-slide5-text p:nth-of-type(2) {
  color: #56c4fd;
  font-size: 2.5em;
  background: linear-gradient(90deg, #56c4fd, #a6dcf8);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.custom-slide5-text p:nth-of-type(3) {
  color: white;
  font-size: 1em;
  text-align: left;
}

.custom-slide4-text2 {
  position: absolute;
  width: 30%;
  color: white;
  top: 30%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;

  p {
    max-width: 100%;
  }
}

.custom-slide4-text2 p:nth-of-type(1) {
  margin-bottom: 200px;
}


.custom-slide4-text {
  position: absolute;
  width: 35%;
  top: 40%;
  left: 1%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;

  p {
    max-width: 100%;
  }
}

.custom-slide4-text p:nth-of-type(1) {
  color: #ffc000;

  font-size: 2.5em;
  margin-bottom: 0px;
}

.custom-slide4-text p:nth-of-type(2) {
  color: white;
  font-size: 2.5em;
}

.custom-slide4-text p:nth-of-type(3) {
  color: white;
  font-size: 1em;
  margin-bottom: 0px;
}


.custom-slide4 {
  display: flex;
  position: relative;
}

.custom-slide4-img {
  width: 38%;
}

.custom-slide4-imgs {
  display: flex;
  width: 100%;

  flex-direction: column;

  img {
    width: 100%;
    height: 50%;
  }
}


.custom-slide {
  display: flex;
}

.custom-slide-img {
  height: 100%;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;


  img {
    height: 100%;
  }
}

.custom-slide-text {
  height: 30%;
  width: 300px;
  color: #83cbeb;
  margin-top: 20px;

  img {
    width: 120%;
    height: 100%;
  }
}

.custom-slide-text p:nth-of-type(1) {
  font-size: 2em;
  color: #83cbeb;
  margin-top: 20px;
  text-align: left;
}

.custom-slide-text2 {
  width: 200%;
  position: relative;
  bottom: 15px;
}

.custom-slide-text2 p:nth-of-type(1) {
  font-size: 1.2em;
  color: white;
  margin-top: 20px;
  text-align: left;
}


.custom-slide2 {
  display: flex;
  flex-direction: column;
}

.custom-slide2-imgs {
  display: flex;
  width: 100%;

  img {
    width: 25%;
    height: 270px;
  }
}

.custom-slide2-text {
  color: white;
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    text-align: left;
  }
}

.custom-slide2-text p:nth-of-type(1) {
  font-size: 2.5em;
  color: #d86ecc;
  margin-bottom: 0px;
}

.custom-slide2-text p:nth-of-type(2) {
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 2.5em;
  color: #d86ecc;
}

.custom-slide2-text p:nth-of-type(3) {
  font-size: 1.2em;
  color: white;
}


.custom-slide3 {
  display: flex;
  flex-direction: column;
}

.custom-slide3-imgs {
  display: flex;
  width: 100%;

  img {
    width: 34%;
    height: 270px;
  }
}

.custom-slide3-text {
  color: white;
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    text-align: left;
  }
}

.custom-slide3-text p:nth-of-type(1) {
  margin-bottom: 0px;
  font-size: 2.5em;
  color: #46b1e1;
}

.custom-slide3-text p:nth-of-type(2) {
  font-size: 1.2em;
  margin-bottom: 0;

}

.custom-slide3-text p:nth-of-type(3) {
  font-size: 1.2em;
  color: white;

}

/* 响应式调整 */
@media (max-width: 765px) {
  .web-view {
    display: none !important;
  }

  .custom-slide-img {
    img {
      width: 100%;
    }
  }


  .custom-slide-text {
    height: 30%;
    width: 300px;
    color: #83cbeb;
    margin-top: 5px;
    margin-left: 10px;

    img {
      width: 95%;
    }

  }

  .custom-slide-text p:nth-of-type(1) {
    font-size: 1.2em;
    color: #83cbeb;
    margin-top: 20px;
    text-align: left;
  }

  .custom-slide-text2 {
    width: 100%;
    position: relative;
    bottom: 15px;
  }

  .custom-slide-text2 p:nth-of-type(1) {
    font-size: 1em;
    color: white;
    margin-top: 20px;
    text-align: left;
  }


  .custom-slide2 {
    display: flex;
    flex-direction: column;
  }

  .custom-slide2-imgs {
    display: flex;
    width: 100%;

    img {
      width: 25%;
      height: 270px;
    }
  }

  .custom-slide2-text p:nth-of-type(1) {
    font-size: 1.5em;
  }

  .custom-slide2-text p:nth-of-type(2) {
    font-size: 1.5em;
  }

  .custom-slide2-text p:nth-of-type(3) {
    font-size: 1em;
  }


  .custom-slide3 {
    display: flex;
    flex-direction: column;
  }

  .custom-slide3-imgs {
    display: flex;
    width: 100%;

    img {
      width: 34%;
      height: 270px;
    }
  }

  .custom-slide3-text {
    color: white;
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      text-align: left;
    }
  }

  .custom-slide3-text p:nth-of-type(1) {
    font-size: 1.5em;
    color: #46b1e1;
  }

  .custom-slide3-text p:nth-of-type(2) {
    font-size: 1em;
    margin-bottom: 0px;

  }

  .custom-slide3-text p:nth-of-type(3) {
    font-size: 1em;
    color: white;
  }


  .custom-slide4-text2 {
    position: absolute;
    width: 40%;
    color: white;
    font-size: 1em;
    top: 30%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
  }

  .custom-slide4-text2 p:nth-of-type(1) {
    margin-bottom: 200px;
  }


  .custom-slide4-text {
    position: absolute;
    width: 35%;
    top: 40%;
    left: -1%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
  }

  .custom-slide4-text p:nth-of-type(1) {
    color: #ffc000;
    font-size: 1.5em;
    margin-bottom: 0px;
  }

  .custom-slide4-text p:nth-of-type(2) {
    color: white;
    font-size: 1.5em;
  }

  .custom-slide4-text p:nth-of-type(3) {
    color: white;
    font-size: 0.7em;
    margin-bottom: 0;
  }


  .custom-slide4 {
    display: flex;
    position: relative;
    width: 100%;
  }

  .custom-slide4-img {
    width: 50%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .custom-slide4-imgs {
    display: flex;
    width: 100%;

    flex-direction: column;

    img {
      width: 100%;
      height: 50%;
    }
  }


  .custom-slide5-image {
    position: absolute;
    bottom: 0;
    height: 35%;
    width: 100%;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .custom-slide5-text {
    position: absolute;
    width: 95%;
    top: 15%;
    left: 10%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .custom-slide5-text p:nth-of-type(1) {
    color: white;
    font-size: 1.5em;
    margin-bottom: 0;
  }

  .custom-slide5-text p:nth-of-type(2) {
    color: #56c4fd;
    font-size: 1.5em;
    background: linear-gradient(90deg, #56c4fd, #a6dcf8);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .custom-slide5-text p:nth-of-type(3) {
    color: white;
    font-size: 1em;
    text-align: left;
  }

  .custom-slide6 {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
  }

  .custom-slide6-text {
    position: relative;
    top: 20%;
    left: 5%;
    width: 50%;
  }

  .custom-slide6-text img:nth-of-type(1) {
    width: 145%;
  }

  .custom-slide6-text img:nth-of-type(2) {
    width: 220%;
  }

  .custom-slide6-imgs {
    width: 50%;
  }

  .custom-slide6-imgs img {
    height: 50%;
  }


  .custom-slide8 {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .custom-slide8-text {
    height: 100%;
    width: 55%;
    display: flex;
    align-items: center;
    justify-content: left;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .custom-slide8-img {
    height: 100%;
    width: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    text-align: left;
    position: relative;
    top: 20%;
    left: 5%;
  }

  .custom-slide8-text1 {
    color: #d86ecc;
    font-size: 1.5em;
  }

  .custom-slide8-text2 {
    color: #808080;
  }

  .custom-slide8-text3 {

  }


  .custom-slide9 {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .custom-slide9-text {
    position: relative;
    width: 45%;
    height: 100%;
    color: white;
    top: 20%;
    left: 5%;
    text-align: left;
  }

  .custom-slide9-text1 {
    font-size: 1.5em;
    color: #61cbf4;
  }

  .custom-slide9-img {
    height: 100%;
    width: 55%;
    display: flex;
    align-items: center;
    justify-content: left;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .custom-slide10 {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .custom-slide10-text {
    position: relative;
    width: 45%;
    height: 100%;
    color: white;
    top: 20%;
    left: 5%;
    text-align: left;
  }

  .custom-slide10-text1 {
    font-size: 1.5em;
    color: #61cbf4;
  }

  .custom-slide10-text2 {
    margin-top: 50px;
  }

  .custom-slide10-img {
    height: 100%;
    width: 55%;
    display: flex;
    align-items: center;
    justify-content: left;
    overflow: hidden;

    img {
      width: 90%;
      height: 90%;
    }
  }
}
</style>
